<template>
	<div @click="showpricehint = false">
		<Top :showtop="1"></Top>
		<div class="wd-container">
			<div class="wd-lh-40 wd-font-16 wd-theme-666 wd-m-t-20">填写并核对订单信息</div>
			<div class="wd-border wd-p-20">
				<div class="wd-flex wd-row-between">
					<span class="wd-font-bold wd-font-16">收货人信息</span>
					<span class="wd-cursor-underline blue wd-blue" @click="editaddr(-1)">新增收货地址</span>
				</div>
				<div class="addrlist">
					<div class="wd-flex wd-row-between row wd-p-r-10" v-for="(item, index) in addrlist" :key="index" @click="selectaddr(index)">
						<div class="a wd-row-noshrink" :class="item.select ? 'select' : ''">{{ item.name }}</div>
						<div class="wd-m-l-20 wd-row-grow">
							{{ item.province }}{{ item.addr }} {{ item.telno | mobileFormatter }}
							<span class="defaultaddr" v-if="item.state == 2">默认地址</span>
						</div>
						<div class="wd-row-noshrink show wd-blue">
							<span class="wd-m-r-10 wd-cursor" v-if="item.state != 2" @click="setdefaultaddr(index)">设为默认地址</span>
							<span class="wd-m-r-10 wd-cursor" @click="editaddr(index)">编辑</span>
							<span class="wd-cursor" @click="deleteaddr(index)">删除</span>
						</div>
					</div>
				</div>
				<el-divider></el-divider>
				<div class="wd-font-bold wd-font-16">配送方式</div>
				<div class="expresslist wd-flex">
					<div class="a" :class="item.select ? 'select' : ''" v-for="(item, index) in ordergetlist" :key="index" @click="selectexpress(index)">{{ item.name }}</div>
				</div>
				<div class="wd-flex wd-row-between wd-m-t-20">
					<div class="wd-font-bold wd-font-16">送货清单</div>
					<div class="wd-flex wd-row-right wd-m-r-10 wd-rela">
						<div class="wd-cursor wd-blue" @click.stop="showpricehint = true">
							<i class="wd-icon wd-warning wd-m-r-10 ">&#xe663;</i>
							<span>价格说明</span>
						</div>
						<div class="wd-m-l-40 wd-cursor wd-blue"><router-link :to="{ name: 'Cart' }" tag="span">返回修改购物车</router-link></div>
						<div class="tooltip" :class="showpricehint ? 'show' : ''">
							因可能存在系统缓存、页面更新导致价格变动异常等不确定性情况出现，商品售价以结算页商品价格为准；如有疑问，请您立即联系客服咨询。
							<span class="tipclose" @click="showpricehint = false">X</span>
							<span class="tiparrow"></span>
						</div>
					</div>
				</div>
				<div class="orderdetail wd-m-t-20" v-for="(sitem, sindex) in cartlist" :key="sindex">
					<div class="wd-m-l-20 wd-font-bold">
						<span class="wd-icon wd-theme-999 wd-m-r-5">&#xe6b9;</span>
						<span>{{sitem.branchname}}</span>
					</div>
					<div class="wdline1 wd-m-tb-10"></div>
					<div class="list wd-flex wd-row-between wd-col-top wd-p-20 wd-border-bottom" v-for="(item, index) in sitem.detail" :key="index">
						<div class="wd-flex wd-p-5 wd-row-grow wd-col-top">
							<div class="wd-img-80"><el-image :src="$wdpicurl(item.pic1)" class="wd-img-80"></el-image></div>
							<div class="wd-row-grow wd-m-l-20 wd-m-r-20">
								<div>{{ item.name }}</div>
								<div v-if="item.free != ''" @click="freemore(stockindex, index)">
									<span class=" wd-m-r-10 ">促销</span>
									<span class="wd-font-12">{{ '买' + item.free.buynum + '赠' + item.free.freenum }}</span>
								</div>
								<div v-if="item.skdetailid != '0'">
									<span class=" wd-m-r-10 ">{{ item.seckillflagtext }}：</span>
									<span class="wd-font-12">限购{{ $weidajs.numberFixed(item.pernum, 0) }}{{ item.unit }}</span>
									<!-- <span class="wd-font-12 wd-m-l-5" v-if="item.seckilldata != ''">
										【可购：{{ $weidajs.numberFixed(item.seckilldata['value']['pernum'],0) }}{{ item.unit }}】
									</span> -->
								</div>
							</div>
						</div>
						<div class="wd-theme wd-font-bold  wd-width-200 wd-p-20">
							<span v-if="flag == 1">积分：{{ item.integralexchange | amountFormatter }}</span>
							<span v-if="flag == 1 && item.integralmoney > 0" class="wd-m-l-10">+¥{{ item.integralmoney | amountFormatter }}</span>
							<span v-if="flag == 0 ">¥{{ item.appprice | amountFormatter }}</span>
							<span v-if="flag == 0 && item.appprice!=item.price1 && item.skdetailid==0" class="pluscss">PLUS</span>
						</div>
						<div class="wd-theme-666 wd-width-100 wd-p-20">x{{item.num}}</div>
						<div class=" wd-width-100 wd-p-20">
							<span class="wd-theme-999" v-if="item.deliver == ''">缺货</span>
							<span class="wd-theme-666">有货</span>
						</div>
					</div>
				</div>
				<div class="wd-m-t-20 wd-flex" v-if="flag == 0">
					<div>
						<span class="wd-font-bold wd-font-16">使用优惠券</span>
						<span class="wd-theme-666 wd-m-l-20">(共有优惠券{{ couponlist.length }}张,可使用优惠券{{ canusecouponnum }}张)</span>
					</div>
					<div class="coupon wd-m-l-20">
						<el-select v-model="couponid" placeholder="请选择优惠券" @change="selectcoupon">
							<el-option
								v-for="item in couponlist"
								:key="item.recid"
								:label="item.name + '(¥' + $weidajs.numberFixed(item.num) + ') ' + item.limitcon"
								:value="item.recid"
								:disabled="item.canuse == 1"
							></el-option>
						</el-select>
					</div>
				</div>
				<!-- <view class="wd-height-40 wdflexb">
					<view class="title">
						订单备注
					</view>
					<view class="value wdflex_grow wdmargin-l-10">
						<input type="text" v-model="buyermemo" placeholder="请输入订单说明:如颜色,尺码要求等" maxlength="50" />
					</view>
				</view> -->
				<div class="wd-m-t-20" v-if="flag == 1">
					<el-checkbox disabled v-model="useintegralflag" @change="useintegral = ''">使用积分余额</el-checkbox>
					<el-input class="wd-m-l-20 wd-width-100" v-model="useintegral" :min="1" :max="9999" disabled></el-input>
					<span class="wd-m-l-10">（您当前积分</span>
					<span class="wd-theme">{{ myinfo.canuseintegral }}</span>
					<span>分）</span>
				</div>
				<div class="wd-m-t-20">
					<el-checkbox v-model="useamountflag" @change="canuseamount = ''">使用账户余额</el-checkbox>
					<el-input
						class="wd-m-l-20 wd-width-100"
						v-model="canuseamount"
						:min="0.1"
						:max="myinfo.canuseamount"
						:disabled="!useamountflag"
						@input="canuseamountchange"
					></el-input>
					<span class="wd-m-l-10">（您当前余额</span>
					<span class="wd-theme">{{ myinfo.canuseamount }}</span>
					<span>元）</span>
				</div>
				<div class="wd-m-t-20">
					<span class="wd-width-100">支付密码：</span>
					<el-input class="wd-m-l-20 wd-width-200" type="password" v-model="paypass" maxlength="6" show-password></el-input>
					<span class="wd-m-l-10 wd-cursor" @click="resetpaypassword">忘记支付密码？</span>
				</div>
				<el-divider></el-divider>
				<div class="wd-flex wd-row-between wd-panel" v-if="buytype==='pintuan'">
					<div></div>
					<div class="wd-flex wd-row-between">
						<div class="wd-font-bold wd-m-r-20 wd-theme">
							<span class="wd-icon  wd-font-14 wd-m-r-5">&#xe6be;</span>
							<span v-if="teamid==''||teamid=='0'">您正在开团购买</span>
							<span v-else>为您加入团</span><!-- 仅差1人的 -->
						</div>
						<div class="wd-flex">
							<div class="wd-theme-999 wd-font-12 wd-m-r-5" v-if="teamid==''||teamid=='0'">支付后邀请好友一起买</div>
							<el-avatar size="medium" :src="$wdpicurl(logininfo.myinfo.headpic,true)"></el-avatar>
							<el-avatar v-if="teamid==''||teamid=='0'" size="medium" :src="nomanpic" style="margin-left: -10px;"></el-avatar>
							<el-avatar v-else size="medium" :src="$wdpicurl(logininfo.myinfo.headpic,true)" style="margin-left: -10px;"></el-avatar>
						</div>
					</div>
				</div>
				<div class="wd-flex wd-row-right">
					<div>
						<div class="wd-flex wd-lh-40">
							<div class="wd-width-200 wd-text-right">{{ selectnum }} 件商品，总商品金额：</div>
							<div class="wd-width-100 wd-text-right">¥{{ selectamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-40">
							<div class="wd-width-200 wd-text-right">优惠券：</div>
							<div class="wd-width-100 wd-text-right">-¥{{ couponamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-40">
							<div class="wd-width-200 wd-text-right">促销优惠：</div>
							<div class="wd-width-100 wd-text-right">-¥{{$weidajs.numberFixed(manjianamount)}}</div>
						</div>
						<div class="wd-flex wd-lh-40">
							<div class="wd-width-200 wd-text-right">运费：</div>
							<div class="wd-width-100 wd-text-right">¥{{ expressamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-40">
							<div class="wd-width-200 wd-text-right">余额支付：</div>
							<div class="wd-width-100 wd-text-right">-¥{{ canuseamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-40">
							<div class="wd-width-200 wd-text-right">积分支付：</div>
							<div class="wd-width-100 wd-text-right">-{{ useintegral | amountFormatter }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tradefoot wd-flex wd-row-right">
				<div>
					<div class="wd-flex wd-lh-40 wd-row-right">
						<div class="wd-width-200 wd-text-right wd-theme-000">应付总额：</div>
						<div class="wd-width-100 wd-text-right wd-theme wd-font-bold wd-font-18">¥{{ needpayamount | amountFormatter }}</div>
					</div>
					<div class="wd-lh-40">寄送至： {{ addrinfo.province }}{{ addrinfo.addr }} 收货人：{{ addrinfo.name }} {{ addrinfo.telno }}</div>
				</div>
			</div>
			<div class="wd-flex wd-row-right wd-p-r-20 wd-m-t-10"><el-button type="primary" :loading="opting" class="wd-p-l-40 wd-p-r-40" @click="save">提交订单</el-button></div>
		</div>
		<Footer></Footer>
		<el-dialog :title="addrtitle" class="addredit" :visible.sync="addrVisible" width="600px" :before-close="addrClose" :close-on-click-modal="false">
			<Addredit :closefun="addrClose" :pid="addrid"></Addredit>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
import Addredit from '@/views/Member/components/Addredit.vue';
export default {
	computed: {
		...mapState(['logininfo']),
		canusecouponnum() {
			var cnt = 0;
			for (var i = 0; i < this.couponlist.length; i++) {
				if (this.couponlist[i].canuse !== 1) {
					cnt++;
				}
			}
			return cnt;
		}
	},
	name: 'Buy',
	components: {
		Top,
		Footer,
		Addredit
	},
	data() {
		return {
			nomanpic:require('@/assets/noman.png'),
			buyerrealinfo: [],
			paypass: '',
			useintegralflag: false,
			useintegral: 0,
			realintegral: 0, //兑换需要的积分
			integralamount: 0,
			useamountflag: false,
			canuseamount: 0,
			cartlist: [],
			picurl: '',
			goodsname: '',
			goodsid: '',
			retailprice: '',
			goodsrate: 0,
			shoprate: 0,
			expressrate: 0,
			hidename: false,
			memo: '',
			addrVisible: false,
			addrtitle: '新增收货地址',
			addrid: '',
			addrlist: [],
			addrindex: -1,
			addrinfo: {},
			showpricehint: false,
			ordergetlist: [{ id: '0', name: '普通配送', amount: 0, select: true }, { id: '1', name: '到店自取', amount: 0 }],
			teamordergetlist: [{ id: '0', name: '自购' }, { id: '1', name: '代客下单' }],
			teamorderget: '0',
			ordergetflag: '0',
			tempordergetflag: '0',
			ordergetflagtext: '普通配送',
			couponlist: [],
			expressamount: 0, //运费
			expressmsg: '',
			selectamount: 0,
			selectnum: 0,
			realamount: 0,
			needpayamount: 0,
			buyername: '',
			buyermobile: '',
			buyermemo: '',
			couponid: '',
			couponname: '无可用',
			couponamount: 0,
			tempcouponid: '',
			skid: '0',
			skflag: '0',
			buyflag: 0,
			barcodeid: 0,
			num: 0,
			skdetailid: 0,
			seckillid: 0,
			sharecode: '',
			stockid: '',
			imei: '',
			freeindex: -1,
			stockindex: -1,
			myinfo: {},
			opting: false,
			flag: 0,
			buytype:'',
			teamid:'',
			sizeid:0,
			colorid:0,
			teamnum:0,
			paypassword:'',
			manjianamount:0,
			cacl_wddatalist:[],
			canuse_yunfeika:false,
			use_yufeika:false
		};
	},
	methods: {
		resetpaypassword(){
			let routeData = this.$router.resolve({
				name: "MemberIndex",
				query: {
					aflag: "Paypassword"
				}
			});
			window.open(routeData.href, '_blank');
		},
		yunfeikaopt()
		{
			if (this.use_yufeika){
				this.realamount=(parseFloat(this.selectamount)-parseFloat(this.couponamount)).toFixed(2);
			}else{
				this.realamount=(parseFloat(this.selectamount)+parseFloat(this.expressamount)-parseFloat(this.couponamount)).toFixed(2);
			}
		},
		resort(data){
			var rs = []
			var i = 0
			var j = 0
			for(j=0;j<data.length;j++){
				for (i = 0; i < data[j].detail.length; i++) {
					let manjianid=data[j].detail[i].manjianid||""
					if (data[j].detail[i].yingxiaolist!=''){
						let idx=-1;
						if (manjianid!==""){
							idx=data[j].detail[i].yingxiaolist.findIndex((item)=>(item.id===manjianid));
						}
						if (idx===-1){
							idx=0;
						}
						data[j].detail[i].yingxiaolist[idx].checkstate=0;
						data[j].detail[i].manjianid=data[j].detail[i].yingxiaolist[idx].id;
						data[j].detail[i].manjianname=data[j].detail[i].yingxiaolist[idx].name;
						data[j].detail[i].manjianlimituse=data[j].detail[i].yingxiaolist[idx].limituse;
						data[j].detail[i].manjianindex="";
						data[j].detail[i].manjianflag=data[j].detail[i].yingxiaolist[idx].flag;
						data[j].detail[i].manjiandetail=data[j].detail[i].yingxiaolist[idx].detail;
					}else{
						data[j].detail[i].manjianid="";
						data[j].detail[i].manjianname="";
						data[j].detail[i].manjianlimituse="";
						data[j].detail[i].manjianindex="";
						data[j].detail[i].manjianflag="";
						data[j].detail[i].manjiandetail="";
					}
				}
			}
			this.cartlist=data;
			for(j=0;j<data.length;j++){
				for (i = 0; i < data[j].detail.length; i++) {
					let manjianitem=data[j].detail[i]
					let manjianid= manjianitem.manjianid||""
					let idx=-1;
					if (rs.length>0){
						idx=rs.findIndex((item)=>(item.manjianid===manjianid));
					}
					if (idx===-1){
						rs.push({
							manjianid:manjianid,
							manjianname:manjianitem.manjianname,
							manjianlimituse:manjianitem.manjianlimituse,
							manjianflag:manjianitem.manjianflag,
							manjiandetail:manjianitem.manjiandetail,
							manjianindex:"",
							detail:[]
						})
					}
				}
			}
			for (i = 0; i < rs.length; i++) {
				for (let k in data){
					for (j = 0; j < data[k].detail.length; j++) {
						if (rs[i].manjianid===data[k].detail[j].manjianid){
							rs[i].detail.push(data[k].detail[j])
						}
					}
				}
			}
			this.cacl_wddatalist=rs;
			this.calc_manjian();
		},
		calc_manjian(){
			//计算满减
			var manjianamount=0;
			// var realamount=0;
			let aamount=0,anum=0,acnt=0;
			let cintegral=0;
			var detail_sort=[];
			for (let mjindex in this.cacl_wddatalist){
				let manjianitem=this.cacl_wddatalist[mjindex];
				let camount=0;
				let cnum=0;
				// let jamount=0;
				// let jnum=0;
				for (let index in manjianitem.detail) {
					let item=manjianitem.detail[index];
					if (item.checkstate==0){
						if (this.flag == 1) {
							//积分兑换
							camount = camount + parseFloat(item.integralmoney) * parseFloat(item.num);
							// +parseFloat(this.expressmoney);
							// +parseFloat(this.cartlist[j].detail[index].deliveramount);
							cintegral = cintegral + parseFloat(item.integralexchange) * parseFloat(item.num);
							aamount=aamount+parseFloat(item.integralmoney) * parseFloat(item.num);
						} else {
							camount = camount + parseFloat(item.realamount);
							aamount=aamount+parseFloat(item.realamount);
							// +parseFloat(this.expressmoney);
							// +	parseFloat(this.cartlist[j].detail[index].deliveramount);
						}
						// camount=camount+parseFloat(item.realamount);
						cnum=cnum+parseInt(item.num);
						// aamount=aamount+parseFloat(item.realamount);
						anum=anum+parseInt(item.num);
						for (var k = 0; k < item.num; k++) {
							detail_sort.push(parseFloat(item.appprice));
						}
						acnt++;
					}
				}
				detail_sort.sort(function(a,b){
					return a<b?1:-1
				})
				if (manjianitem.manjianid||""!==""){
					if (manjianitem.manjianlimituse==0){//金额满减送
						let limitamount=0;
						let freeamount=0;
						let manjianindex=0;
						for(let j in manjianitem.manjiandetail){
							if (camount>=parseFloat(manjianitem.manjiandetail[j].limitamount)){
								limitamount=parseFloat(manjianitem.manjiandetail[j].limitamount);
								freeamount=parseFloat(manjianitem.manjiandetail[j].freeamount);
								manjianindex=j;
							}
						}
						manjianitem.freeamount=freeamount;
						manjianitem.limitamount=limitamount;
						manjianitem.manjianindex=manjianindex;
						manjianamount=manjianamount+freeamount;
					}else if (manjianitem.manjianlimituse==1){//数量满减送
						let limitamount=0;
						let freeamount=0;
						let manjianindex=0;
						let cha=detail_sort.length-manjianitem.manjiandetail.length;
						if (cha<0){
							cha=0;
						}
						for(let j in manjianitem.manjiandetail){
							if (manjianitem.manjianflag=='1'){//满减
								if (cnum>=parseFloat(manjianitem.manjiandetail[j].limitamount)){
									limitamount=parseFloat(manjianitem.manjiandetail[j].limitamount);
									freeamount=parseFloat(manjianitem.manjiandetail[j].freeamount);
									manjianindex=j;
								}
							}else if (manjianitem.manjianflag=='3'){//阶梯
								let chavalue=parseInt(j)+parseInt(cha);
								if (detail_sort.length>chavalue){
									if (cnum>=parseFloat(manjianitem.manjiandetail[j].limitamount)){
										limitamount=parseFloat(manjianitem.manjiandetail[j].limitamount);
										let tmp_amount=0;
										if (manjianitem.manjiandetail[j].freeamount>0){
											tmp_amount=parseFloat(manjianitem.manjiandetail[j].freeamount);
										}else if (manjianitem.manjiandetail[j].freediscount<1){
											tmp_amount=(1-parseFloat(manjianitem.manjiandetail[j].freediscount))*parseFloat(detail_sort[chavalue]);
										}else if (manjianitem.manjiandetail[j].newamount!=-1){
											tmp_amount=parseFloat(detail_sort[chavalue])-parseFloat(manjianitem.manjiandetail[j].newamount);
										}
										freeamount=freeamount+tmp_amount;
										manjianindex=j;
									}
								}
							}
						}
						manjianitem.freeamount=freeamount;
						manjianitem.limitamount=limitamount;
						manjianitem.manjianindex=manjianindex;
						manjianamount=manjianamount+freeamount;
					}
				}
			}
			this.manjianamount=manjianamount;
			// this.selectamount = aamount-manjianamount.toFixed(2);
			// this.selectnum = anum;
			// this.realamount = (aamount-manjianamount+parseFloat(this.expressamount)-parseFloat(this.couponamount)).toFixed(2);
			console.log(acnt);
			this.selectamount = aamount.toFixed(2);
			this.selectnum = anum;
			let canuseamount = 0;
			if (this.$weidajs.isEmpty(this.canuseamount)) {
				canuseamount = 0;
			} else {
				canuseamount = parseFloat(this.canuseamount);
			}
			this.needpayamount = (aamount -manjianamount + parseFloat(this.expressamount) - parseFloat(this.couponamount) - canuseamount).toFixed(2);
			this.realamount =  (aamount -manjianamount + parseFloat(this.expressamount) - parseFloat(this.couponamount)).toFixed(2);
			if (this.flag == 1) {
				this.realintegral = cintegral;
				this.useintegral = this.realintegral;
				this.useintegralflag = true;
			}
		},
		freemore(stockindex, index) {
			this.stockindex = stockindex;
			this.freeindex = index;
		},
		setordergetflag() {
			this.ordergetflag = this.tempordergetflag;
			if (this.ordergetflag == '0') {
				this.expressamount = this.ordergetlist[0].amount;
				if (this.expressamount > 0) {
					this.ordergetflagtext = this.ordergetlist[0].name + '(费用¥ ' + this.ordergetlist[0].amount + ')';
				} else {
					this.ordergetflagtext = this.ordergetlist[0].name + '(免费)';
				}
			} else if (this.ordergetflag == '1') {
				this.expressamount = this.ordergetlist[1].amount;
				this.ordergetflagtext = this.ordergetlist[1].name;
			}
			this.countall();
		},
		canuseamountchange() {
			var a = this.canuseamountfinish();
			if (!a) {
				this.canuseamount = '0';
				this.countall();
			} else {
				this.countall();
			}
		},
		canuseamountfinish() {
			var ye = parseFloat(this.canuseamount);
			if (this.$weidajs.isEmpty(ye)) {
				ye = 0;
				this.canuseamount = '0';
				return true;
			}
			if (ye < 0) {
				this.$wd_toast('余额支付金额不能小于0');
				return;
			}
			var ye2 = parseFloat(this.myinfo.canuseamount);
			if (this.$weidajs.isEmpty(ye2)) {
				ye2 = 0;
			}
			if (ye > ye2) {
				this.$wd_toast('本次余额支付金额超出账户余额¥' + this.myinfo.canuseamount, 'error');
				this.canuseamount = '0';
				return false;
			}
			if (ye > this.realamount) {
				this.$wd_toast('余额支付金额超出订单余额¥' + this.realamount, 'error');
				this.canuseamount = '0';
				return false;
			}
			return true;
		},
		selectcoupon(e) {
			this.tempcouponid = e;
		},
		setcoupon() {
			if (this.tempcouponid !== '') {
				var item = this.couponlist.find(data => data.recid == this.tempcouponid);
				if (item !== undefined) {
					this.couponid = item.recid;
					this.couponname = item.name;
					this.couponamount = item.num;
				}
			} else {
				this.couponame = '未选择优惠券';
			}
			this.countall();
		},
		changeteamorderget() {
			this.couponid = '';
			this.couponname = '无可用';
			this.couponamount = 0;
			this.tempcouponid = '';
			this.couponlist = [];
			this.loadlist();
		},
		selectexpress(index) {
			for (var i = 0; i < this.ordergetlist.length; i++) {
				if (i === index) {
					this.ordergetlist[i].select = true;
					this.tempordergetflag=this.ordergetlist[i].id;
				} else {
					this.ordergetlist[i].select = false;
				}
			}
			
			this.ordergetflag = this.tempordergetflag;
			if (this.ordergetflag == '0') {
				this.expressamount = this.ordergetlist[0].amount;
				if (this.expressamount > 0) {
					this.ordergetflagtext = this.ordergetlist[0].name + '(费用¥ ' + this.ordergetlist[0].amount + ')';
				} else {
					this.ordergetflagtext = this.ordergetlist[0].name + '(免费)';
				}
			} else if (this.ordergetflag == '1') {
				this.expressamount = this.ordergetlist[1].amount;
				this.ordergetflagtext = this.ordergetlist[1].name;
			}
			this.countall();
		},
		setdefaultaddr(index) {
			var addrid = this.addrlist[index].id;
			this.$wd_request('setdefaultaddr', { addrid: addrid }, true).then(() => {
				for (var i = 0; i < this.addrlist.length; i++) {
					if (i !== index) {
						this.addrlist[i].state = 0;
					} else {
						this.addrlist[i].state = 2;
					}
				}
			});
		},
		selectaddr(index) {
			this.addrindex = index;
			for (var i = 0; i < this.addrlist.length; i++) {
				if (i !== index) {
					this.addrlist[i].select = false;
				} else {
					this.addrlist[i].select = true;
				}
			}

			this.addrinfo = this.addrlist[index];
		},
		addrClose(issave = false) {
			if (issave) {
				if (this.addrindex == -1) {
					this.loadaddrlist();
				} else {
					this.$wd_request('addr', { addrid: this.addrlist[this.addrindex].id }, true).then(data => {
						var addrinfo = data.value;
						addrinfo.select = true;
						this.$set(this.addrlist, this.addrindex, addrinfo);
					});
				}
			}
			this.addrVisible = false;
		},
		deleteaddr(index) {
			this.$confirm('确定删除该地址信息吗？', '温馨提示').then(() => {
				var addrid = this.addrlist[index].id;
				this.$wd_request('deladdr', { addrid: addrid }).then(() => {
					this.addrlist.splice(index, 1);
				});
			});
		},
		editaddr(index) {
			this.addrindex = index;
			if (index === -1) {
				this.addrtitle = '新增收货地址';
				this.addrid = '';
			} else {
				this.addrtitle = '修改收货地址';
				this.addrid = this.addrlist[index].id;
			}
			this.addrVisible = true;
		},
		loadcart() {
			var pro = '';
			if (this.hasdefaultaddr) {
				pro = this.addrinfo.province;
			}
			var buyermobile = '';
			if (this.teamorderget == 1) {
				buyermobile = this.addrinfo.telno;
			}
			let indata = {
				buyflag: this.buyflag,
				barcodeid: this.barcodeid,
				num: this.num,
				skdetailid: this.skdetailid,
				sharecode: this.sharecode,
				imei: this.imei,
				stockid: this.stockid,
				deliverid: this.deliverid,
				province: pro,
				seckillid: this.seckillid,
				buyermobile: buyermobile,
				teamid:this.teamid,
				sizeid:this.sizeid,
				colorid:this.colorid,
				teamnum:this.teamnum
			};
			this.$wd_request('buycartlist', indata, true).then(data => {
				this.cartlist = data.value;
				if (this.cartlist[0].expressdata !== '') {
					if (this.cartlist[0].coupondata != '' && this.cartlist[0].coupondata.rs == 0) {
						this.couponlist = this.cartlist[0].coupondata.value;
					}
					var couponcnt = 0;
					var tmpcid = '';
					if (this.flag == 0) {
						for (var i = 0; i < this.couponlist.length; i++) {
							if (this.couponlist[i].canuse == 0) {
								if (tmpcid == '') {
									tmpcid = this.couponlist[i].recid;
								}
								couponcnt++;
							}
						}
						if (couponcnt > 0) {
							if (tmpcid != '') {
								this.tempcouponid = tmpcid;
								this.setcoupon();
								// tmpcid=that.couponlist[i].id;
							}
							// that.couponname="请选择优惠券";
						}
					}
					this.expressmsg = this.cartlist[0].expressdata.msg;
					this.expressamount = this.cartlist[0].expressdata.value;
					if (this.cartlist[0].expressdata.value > 0) {
						this.ordergetlist[0].amount = this.expressamount; //+" (¥:"+that.$weidajs.numberFixed(that.expressamount)+"元)";
						this.ordergetflagtext = this.ordergetlist[0].name + '(费用¥ ' + this.ordergetlist[0].amount + ')';
					} else {
						this.ordergetlist[0].amount = 0; //
						this.ordergetflagtext = this.ordergetlist[0].name + '(免费)';
					}
				}
				this.getstocknum();
				this.getstockamount();
				this.resort(data.value);
			});
		},
		loadyunfeika(){
			this.$wd_request("yunfeika",{})
			.then(()=>{
				this.canuse_yunfeika=true;
			})
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		loadaddrlist() {
			this.$wd_request('addr', { addrid: '' }).then(data => {
				this.addrlist = data.value;
				this.addrlist[0].select = true;
				this.addrinfo = this.addrlist[0];
			});
		},
		loadmeminfo() {
			this.$wd_request('meminfo', {}).then(data => {
				this.myinfo = data.value;
			});
		},
		save() {
			this.opting = true;
			var canuseamount = parseFloat(this.canuseamount);
			if (!this.$weidajs.isEmpty(canuseamount) && canuseamount != 0) {
				if (canuseamount < 0) {
					this.$wd_toast('余额支付金额不能小于0', 'error');
					this.opting = false;
					return;
				}
				if (this.$weidajs.isEmpty(this.paypass) || this.paypass.length !== 6) {
					this.$wd_toast('请输入余额支付密码：6位数字', 'error');
					this.opting = false;
					return;
				}
				var reg = /^\d{6}\b/;
				if (!reg.test(this.paypass)) {
					this.$wd_toast('请输入余额支付密码：6位数字', 'error');
					this.opting = false;
					return;
				}
			} else {
				canuseamount = 0;
			}
			var canuseintegral = parseFloat(this.useintegral);
			if (!this.$weidajs.isEmpty(canuseintegral) && canuseintegral != 0) {
				if (canuseintegral < 0) {
					this.$wd_toast('积分兑换额不能小于0', 'error');
					this.opting = false;
					return;
				}
				var mcanuseintegral = parseFloat(this.logininfo.myinfo.canuseintegral);
				if (canuseintegral > mcanuseintegral) {
					this.$wd_toast('积分兑换额不能大于可用积分[' + mcanuseintegral + ']', 'error');
					this.opting = false;
					return;
				}
				if (this.$weidajs.isEmpty(this.paypass) || this.paypass.length !== 6) {
					this.$wd_toast('请输入积分支付密码：6位数字', 'error');
					this.opting = false;
					return;
				}
			} else {
				canuseintegral = 0;
			}
			var buyermobile = '';
			var buyername = '';
			if (this.teamorderget == 1) {
				buyermobile = this.addrinfo.telno;
				buyername = this.addrinfo.name;
			}
			var memlevelflag =1;
			if (this.flag == 1) {
				memlevelflag = 4;
			}
			let indata = {
				teammemguid: '', //this.logininfo.teammemguid,
				memguid: this.myinfo.memguid,
				addrid: this.addrinfo.id,
				express: 0,
				realamount: this.realamount,
				receiptamount: this.realamount,
				num: this.selectnum,
				memo: this.buyermemo,
				couponid: this.couponid,
				skid: this.skid,
				skflag: this.skflag,
				posdetail: this.cartlist,
				buyername: buyername,
				buyermobile: buyermobile,
				stockid: this.stockid,
				imei: this.imei,
				deliverid: this.deliverid,
				ordergetflag: this.ordergetflag,
				expressmoney: this.expressamount,
				teamorderget: this.teamorderget,
				canuseamount: canuseamount,
				canuseintegral: canuseintegral,
				memlevelflag: memlevelflag,
				paypass: this.$crypto.MD5(this.paypass).toString(),
				teamid:this.teamid,
				teamnum:this.teamnum,
				yunfeika:this.use_yufeika
			};
			if (this.buyerrealinfo != '') {
				indata.realname = this.buyerrealinfo.name;
				indata.realidno = this.buyerrealinfo.idno;
				indata.realpic1 = this.buyerrealinfo.pic1;
				indata.realpic2 = this.buyerrealinfo.pic2;
				indata.buyername = this.buyerrealinfo.name;
			} else {
				indata.realname = '';
				indata.realidno = '';
				indata.realpic1 = '';
				indata.realpic2 = '';
			}
			this.$wd_request('saveorder', indata)
				.then(data => {
					this.$wd_toast(data.msg);
					console.log(data);
					let posid = '';
					let payamount = 0;
					for (var i = 0; i < data.value.length; i++) {
						posid = posid + data.value[i].id + ',';
						payamount = payamount + parseFloat(data.value[i].realamount);
					}
					posid = posid + '0';
					// this.$wd_settabbage(1);
					if (payamount == 0) {
						this.$router.push({
							name: 'Paysuccess',
							query: { posid: posid, orderno: data.value[0].listseqno }
						});
					} else {
						this.$router.push({
							name: 'Pay',
							query: { posid: posid, orderno: data.value[0].listseqno }
						});
					}
				})
				.catch(data => {
					this.opting = false;
					this.$wd_msg(data.msg);
				});
		},
		countall() {
			this.calc_manjian();
				return;
			// let camount = 0,
			// 	cnum = 0,
			// 	cintegral = 0;
			// for (let j in this.cartlist) {
			// 	for (let index in this.cartlist[j].detail) {
			// 		if (this.cartlist[j].detail[index].checkstate == 0) {
			// 			if (this.flag == 1) {
			// 				//积分兑换
			// 				camount = camount + parseFloat(this.cartlist[j].detail[index].integralmoney) * parseFloat(this.cartlist[j].detail[index].num);
			// 				// +parseFloat(this.expressmoney);
			// 				// +parseFloat(this.cartlist[j].detail[index].deliveramount);
			// 				cintegral = cintegral + parseFloat(this.cartlist[j].detail[index].integralexchange) * parseFloat(this.cartlist[j].detail[index].num);
			// 			} else {
			// 				camount = camount + parseFloat(this.cartlist[j].detail[index].price1) * parseFloat(this.cartlist[j].detail[index].num);
			// 				// +parseFloat(this.expressmoney);
			// 				// +	parseFloat(this.cartlist[j].detail[index].deliveramount);
			// 			}
			// 			cnum = cnum + parseInt(this.cartlist[j].detail[index].num);
			// 		}
			// 	}
			// }
			// this.selectamount = camount.toFixed(2);
			// this.selectnum = cnum;
			// let canuseamount = 0;
			// if (this.$weidajs.isEmpty(this.canuseamount)) {
			// 	canuseamount = 0;
			// } else {
			// 	canuseamount = parseFloat(this.canuseamount);
			// }
			// this.needpayamount = (camount + parseFloat(this.expressamount) - parseFloat(this.couponamount) - canuseamount).toFixed(2);
			// this.realamount = (camount + parseFloat(this.expressamount) - parseFloat(this.couponamount)).toFixed(2);
			// if (this.flag == 1) {
			// 	this.realintegral = cintegral;
			// 	this.useintegral = this.realintegral;
			// 	this.useintegralflag = true;
			// }
		},
		getstocknum() {
			for (let j in this.cartlist) {
				let camount = 0,
					cnum = 0;
				for (let index in this.cartlist[j].detail) {
					if (this.cartlist[j].detail[index].checkstate == 0) {
						camount = camount + parseFloat(this.cartlist[j].detail[index].price1) * parseFloat(this.cartlist[j].detail[index].num);
						// +parseFloat(this.expressamount);
						cnum = cnum + parseInt(this.cartlist[j].detail[index].num);
					}
				}
				this.cartlist[j].num = cnum;
			}
		},
		getstockamount() {
			for (let j in this.cartlist) {
				let camount = 0,
					cnum = 0;
				for (let index in this.cartlist[j].detail) {
					if (this.cartlist[j].detail[index].checkstate == 0) {
						camount = camount + parseFloat(this.cartlist[j].detail[index].price1) * parseFloat(this.cartlist[j].detail[index].num);
						// +parseFloat(this.cartlist[j].detail[index].deliveramount);
						cnum = cnum + parseInt(this.cartlist[j].detail[index].num);
					}
				}
				this.cartlist[j].amount = (camount + parseFloat(this.expressamount)).toFixed(2);
			}
		}
	},
	activated() {},
	created() {
		this.loadaddrlist();
		var e = this.$route.query;
		this.buyflag = e.buyflag || '0';
		this.num = e.num || '0';
		this.barcodeid = e.barcodeid || '0';
		this.skdetailid = e.skdetailid || '0';
		this.seckillid = e.seckillid || '0';
		if (this.seckillid == 'undefined') {
			this.seckillid = '0';
		}
		var flag = e.flag || 0;
		flag = parseInt(flag);
		if (flag !== 0 && flag !== 1) {
			flag = 0;
		}
		this.flag = flag;
		this.sharecode = e.sharecode || '';
		this.buyername = ''; //this.logininfo.myinfo.name;
		this.buyermobile = ''; //this.logininfo.myinfo.mobile;
		this.imei = e.imei || '';
		this.stockid = e.stockid || '0';
		this.deliverid = e.deliverid || '0';
		this.buytype=e.buytype||"";
		this.teamid=e.teamid||"";
		this.colorid=e.colorid||0;
		this.sizeid=e.sizeid||0;
		this.teamnum=e.teamnum||0;
		if (this.buytype=="pintuan"){
			this.skflag=1;
		}else if (this.buytype=="kanjia"){
			this.skflag=2;
		}else if (this.buytype=="yushou"){
			this.skflag=3;
		}
		this.loadcart();
		this.loadmeminfo();
	}
};
</script>
<style lang="scss">
.coupon {
	.el-select {
		width: 400px;
	}
}
</style>
<style lang="scss" scoped>
.tooltip {
	position: absolute;
	padding: 10px;
	background: #fffdee;
	border: 1px solid #edd28b;
	box-shadow: 0 0 2px 2px #eee;
	z-index: 20;
	top: 30px;
	left: -10px;
	color: #666;
	display: none;
	&.show {
		display: block;
	}
	.tipclose {
		display: block;
		float: right;
		cursor: pointer;
		color: #f60;
		font-size: 12px;
		position: absolute;
		top: 0;
		right: 5px;
	}
	.tiparrow {
		display: block;
		position: absolute;
		background-image: url(../../../public/img/tips.gif);
		background-repeat: no-repeat;
		width: 11px;
		height: 6px;
		background-position: 0 0;
		overflow: hidden;
		left: 10px;
		top: -6px;
		right: auto;
	}
}
.tradefoot {
	padding: 15px 20px 15px 0;
	margin-top: 10px;
	line-height: 20px;
	text-align: right;
	border-top: 1px solid #e6e6e6;
	color: #999;
	background-color: #f4f4f4;
}
.orderdetail {
	background-color: #f3fbfe;
	padding: 10px 0;
	.list {
	}
}
.expresslist {
	margin-top: 20px;
	.a {
		width: 140px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		margin-right: 15px;
		border: 1px solid #ddd;
		position: relative;
		cursor: pointer;
		&:hover {
			border: 2px solid $wd-theme;
		}
		&.select {
			border: 2px solid $wd-theme;
			background: url(../../assets/selected-icon.png) no-repeat 128px 18px;
		}
	}
}
.addrlist {
	margin-top: 20px;
	margin-bottom: 15px;
	color: #666666;
	.row {
		margin: 5px 0;
		.show {
			display: none;
		}
		&:hover {
			background-color: #fff3f3;
			.show {
				display: block;
			}
		}
		.a {
			width: 140px;
			height: 30px;
			text-align: center;
			line-height: 30px;
			border: 1px solid #ddd;
			position: relative;
			cursor: pointer;
			&:hover {
				border: 2px solid $wd-theme;
			}
			&.select {
				border: 2px solid $wd-theme;
				background: url(../../assets/selected-icon.png) no-repeat 128px 18px;
			}
		}
		.defaultaddr {
			margin: 5px 10px;
			background-color: #999;
			color: #fff;
			padding: 3px 5px;
			line-height: 20px;
		}
	}
}
</style>
